import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "react-lazy-load-image-component/src/effects/black-and-white.css";
import "react-lazy-load-image-component/src/effects/opacity.css";

const Image = ({ src, width, height, alt, effect, classes, onChange }) => {
  return (
    <>
      <LazyLoadImage
        src={src}
        width={width}
        height={height}
        alt={alt}
        effect={effect}
        onChange={onChange}
        className={"w-full h-full object-cover " + classes}
      />
    </>
  );
};

export default Image;
